export enum DragDropFileSelectError {
  MAX_FILE_SIZE = 'maxFileSize',
  UN_SUPPORTED_FORMAT = 'unSupportedFormat',
}
